import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

import tickCircleGreen from "../../assets/images/common/tick-transparent.svg";

import Button from "../../components/ui/Button";
import InputBox from "../../components/ui/InputBox";

import LeftSection from "../../components/PreLogin/LoginPage/LeftSection";
import RightFooter from "../../components/PreLogin/RightFooter";

import { useDispatch, useSelector } from 'react-redux';
import { resend } from "../../store/actions/registerAction";

import "./index.scss";
import ReCAPTCHA from "react-google-recaptcha";

const googleRecaptchaSitekey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY;

const Resend = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [addEmailStep, setAddEmailStep] = useState(1);
    const [loginFailed, setLoginFailed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const response = useSelector(state => state.register.resendResponse);

    const inputChange = (val, type) => {
        const handlers = {
            email: setEmail,
        };
        handlers[type] && handlers[type](val);
    };

    useEffect(() => {
        if (response) {
            if (response.detail?.status === "success") {
                setAddEmailStep(2); // Go to success confirmation step
            } else {
                setLoginFailed(true); // Handle failure
            }
            setIsLoading(false)
        }
    }, [response]);

    const isDisabledButton = useCallback(() => {
        if (addEmailStep === 1) {
            return !email || !captchaVerified; // Enable only if email and ReCAPTCHA are valid
        }
        return false; // Allow button by default for other steps
    }, [addEmailStep, email, captchaVerified]);

    const handleResend = () => {
        if (email) {
            setIsLoading(true)
            dispatch(resend({ email }));
        }
    };

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value); // Set to true if value is not null
    };

    const maskEmail = (email) => {
        const [name, domain] = email.split('@');
        if (!domain) return email;
        const maskedName = name.length <= 2 ? `${name[0]}****` : `${name[0]}****${name.slice(-1)}`;
        return `${maskedName}@${domain}`;
    };


    return (
        <div className='validated-container'>
            <Row className='h-100 m-0'>
                <Col md="6">
                    <LeftSection />
                </Col>
                <Col md="6">
                    <div className='validated-right-section px-3 mx-3 h-100'>
                        <div className='right-container'>
                            {addEmailStep === 1 && (
                                <div>
                                    <h1>{t("registrationPage.resend.heading")}</h1>
                                    <p className='mb-3'>{t("registrationPage.resend.secondaryText")}</p>
                                    {loginFailed && (
                                        <p className="error-msg text-center mt-3">
                                            {response?.description}
                                        </p>
                                    )}
                                    <InputBox
                                        placeholder="Enter Email ID"
                                        inputType="email"
                                        inputLabel="Email ID"
                                        inputValue={email}
                                        inputChange={inputChange}
                                    />
                                    <div className='loggedin-checkbox'>
                                        <label style={{ marginBottom: '5px' }}>Captcha</label>
                                        <ReCAPTCHA
                                            sitekey={googleRecaptchaSitekey}
                                            size="normal"
                                            onChange={handleCaptchaChange} // Capture ReCAPTCHA status
                                        />
                                    </div>
                                    <div className='submit-button mt-4'>
                                        <Button
                                            buttonText={"Resend Confirmation Link"}
                                            buttonType="primary"
                                            buttonClicked={handleResend}
                                            disableButton={isDisabledButton() || isLoading}
                                        />
                                    </div>
                                </div>
                            )}
                            {addEmailStep === 2 && (
                                <div>
                                    <img src={tickCircleGreen} alt="confirmation tick" />
                                    <h2 className="mb-3">{t("registrationPage.resend.resendLink")}</h2>
                                    <p>{`Account confirmation link has been sent successfully to your registered mail ID - ${maskEmail(email)}`}</p>
                                    {/* <p className='mt-4'>Didn't receive the email Link Yet? <Link to="/auth/resend">Resend Link</Link></p> */}
                                </div>
                            )}
                        </div>
                        <RightFooter />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Resend;
